module.exports = __webpack_public_path__ + "public/images/slider/vebber.0ce963092b5e55122bf9bab1631e9e20.png";